import React from 'react';
import { RotateCcw, AlertTriangle, X, Check } from 'lucide-react';

export default function DangerZone({ cleaning, isResetting, resetProgress, showResetModal, onShowResetModal, onHideResetModal, onEmergencyReset }) {
  return (
    <>
      {/* EMERGENCY RESET OVERLAY */}
      {isResetting && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-sm">
          <div className="text-center">
            <div className="w-28 h-28 mx-auto mb-6 relative">
              <div className="absolute inset-0 border-4 border-red-500/30 rounded-full animate-ping"></div>
              <div className="absolute inset-0 border-4 border-transparent border-t-red-500 rounded-full animate-spin"></div>
              <div className="absolute inset-3 bg-gradient-to-br from-red-600/20 to-orange-600/20 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-10 h-10 text-red-500" />
              </div>
            </div>
            <h2 className="text-3xl font-bold text-white mb-2">Emergency Reset</h2>
            <p className="text-gray-400 mb-6">Killing processes and cleaning system...</p>
            <div className="w-72 mx-auto h-2 bg-gray-800 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-red-500 to-orange-500 transition-all duration-300" style={{ width: `${resetProgress}%` }}></div>
            </div>
            <p className="text-gray-500 text-sm mt-3">{resetProgress}% Complete</p>
          </div>
        </div>
      )}

      {/* RESET CONFIRMATION MODAL */}
      {showResetModal && (
        <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/80 backdrop-blur-sm">
          <div className="bg-gray-900 border border-red-500/30 rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 bg-red-500/20 rounded-xl">
                <AlertTriangle className="w-7 h-7 text-red-500" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Emergency Reset</h3>
                <p className="text-gray-500 text-sm">This action cannot be undone</p>
              </div>
            </div>
            <div className="bg-black/50 rounded-xl p-4 mb-6">
              <p className="text-gray-400 text-sm mb-3">This will:</p>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center gap-2 text-red-400">
                  <span className="w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                  Kill all Chrome processes
                </li>
                <li className="flex items-center gap-2 text-red-400">
                  <span className="w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                  Stop all workers
                </li>
                <li className="flex items-center gap-2 text-yellow-400">
                  <span className="w-1.5 h-1.5 bg-yellow-500 rounded-full"></span>
                  Reset stuck tasks
                </li>
                <li className="flex items-center gap-2 text-green-400">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                  Restart queue automatically
                </li>
              </ul>
            </div>
            <div className="flex gap-3">
              <button onClick={onHideResetModal} className="flex-1 px-4 py-3 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-xl transition font-medium flex items-center justify-center gap-2">
                <X className="w-4 h-4" /> Cancel
              </button>
              <button onClick={onEmergencyReset} className="flex-1 px-4 py-3 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-500 hover:to-orange-500 text-white rounded-xl transition font-medium flex items-center justify-center gap-2">
                <Check className="w-4 h-4" /> Confirm Reset
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DANGER ZONE BUTTON */}
      <div className="bg-gray-900 border border-red-500/30 rounded-xl p-4 lg:p-5">
        <h3 className="text-red-400 font-bold text-base lg:text-lg mb-4">DANGER ZONE</h3>
        <button onClick={onShowResetModal} disabled={cleaning || isResetting}
          className="w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 disabled:from-gray-700 disabled:to-gray-700 px-6 py-4 rounded-xl font-bold flex items-center justify-center gap-2 border border-red-500/50 shadow-lg transition-all">
          <RotateCcw className={`w-5 h-5 ${isResetting ? 'animate-spin' : ''}`} />
          EMERGENCY SYSTEM RESET
        </button>
        <p className="text-xs text-gray-500 text-center mt-2">Kills all processes, cleans system, restarts workers</p>
      </div>
    </>
  );
}
